import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FieldWorker } from 'src/shared/api';
import { Router } from '@angular/router';
import { displayDescription } from 'src/shared/enums';
import { BehaviorSubject } from 'rxjs';
import { personnelFragments } from 'src/admin-app/personnel/personnel.routes';

@Component({
	selector: 'rpfsa-rwic-list',
	templateUrl: './rwic-list.component.html',
	styleUrls: ['./rwic-list.component.scss'],
})
export class RwicListComponent implements AfterViewInit {
	private loading = new BehaviorSubject<boolean>(true);
	loading$ = this.loading.asObservable();

	@Input()
	set rwics(rwics: FieldWorker[]) {
		if (rwics) {
			this.loading.next(false);
			this.dataSource.data = rwics;
		}
	}

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	emptyColumns = ['empty'];
	resultColumns = ['lastName', 'type', 'employeeCode', 'status'];

	dataSource = new MatTableDataSource<FieldWorker>([]);

	displayDescription = displayDescription;
	personnelFragments = personnelFragments;

	constructor(public readonly router: Router) {}

	ngAfterViewInit() {
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginator;
	}
}
